import { useState } from "react";
import TabBox, { Tab } from "../../../Components/Tabbox/TabBox";
import OffsetDeltaGamma from "../../../Tables/DeltaHedgeExePhase3/DetailedState/Adjustment/OffsetDeltaGamma";
import DeltaGamma from "../../../Tables/DeltaHedgeExePhase3/DetailedState/Adjustment/DeltaGamma";
import Delta from "../../../Tables/DeltaHedgeExePhase3/DetailedState/Adjustment/Delta";
import { IDetailedStateAdjustmentTablesSearchParam } from "../../../Interfaces/deltaHedgeExe";
import EmergencyOffset from "../../../Tables/DeltaHedgeExePhase3/DetailedState/Adjustment/EmergencyOffset";
import OffsetDelta from "../../../Tables/DeltaHedgeExePhase3/DetailedState/Adjustment/OffsetDelta";

enum SelectedTab {
  OffsetDeltaGamma,
  OffsetDelta,
  DeltaGamma,
  Delta,
  EmergencyOffset,
}

interface IProps {
  searchParams: IDetailedStateAdjustmentTablesSearchParam;
}

const TablesWrapper = ({ searchParams }: IProps) => {
  const [selectedTab, setSelectedTab] = useState(SelectedTab.OffsetDeltaGamma);

  const tabs: Tab[] = [
    { index: SelectedTab.OffsetDeltaGamma, title: "تعدیل آفستی دلتا و گاما" },
    { index: SelectedTab.OffsetDelta, title: "تعدیل آفستی دلتا" },
    { index: SelectedTab.DeltaGamma, title: "تعدیل ورودی دلتا و گاما" },
    { index: SelectedTab.Delta, title: "تعدیل ورودی دلتا" },
    { index: SelectedTab.EmergencyOffset, title: "تعدیل آفستی اضطراری" },
  ];

  const getTable = () => {
    switch (selectedTab) {
      case SelectedTab.OffsetDeltaGamma:
        return (
          <div className="grid grid-cols-2 w-full gap-5">
            <div className="flex flex-col justify-start items-start gap-1">
              افزایش دلتا - افزایش گاما
              <OffsetDeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: true,
                  incGamma: true,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              افزایش دلتا - کاهش گاما
              <OffsetDeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: true,
                  incGamma: false,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              کاهش دلتا - افزایش گاما
              <OffsetDeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: false,
                  incGamma: true,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              کاهش دلتا - کاهش گاما
              <OffsetDeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: false,
                  incGamma: false,
                }}
              />
            </div>
          </div>
        );

      case SelectedTab.Delta:
        return (
          <div className="grid grid-cols-2 w-full gap-5">
            <div className="flex flex-col justify-start items-start gap-1">
              افزایش دلتا
              <Delta
                searchParams={{
                  ...searchParams,
                  incDelta: true,
                  incGamma: null,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              کاهش دلتا
              <Delta
                searchParams={{
                  ...searchParams,
                  incDelta: false,
                  incGamma: null,
                }}
              />
            </div>
          </div>
        );

      case SelectedTab.DeltaGamma:
        return (
          <div className="grid grid-cols-2 w-full gap-5">
            <div className="flex flex-col justify-start items-start gap-1">
              افزایش دلتا - افزایش گاما
              <DeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: true,
                  incGamma: true,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              افزایش دلتا - کاهش گاما
              <DeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: true,
                  incGamma: false,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              کاهش دلتا - افزایش گاما
              <DeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: false,
                  incGamma: true,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              کاهش دلتا - کاهش گاما
              <DeltaGamma
                searchParams={{
                  ...searchParams,
                  incDelta: false,
                  incGamma: false,
                }}
              />
            </div>
          </div>
        );

      case SelectedTab.EmergencyOffset:
        return (
          <div className="grid grid-cols-2 w-full gap-5">
            <div className="flex flex-col justify-start items-start gap-1">
              افزایش دلتا
              <EmergencyOffset
                searchParams={{
                  ...searchParams,
                  incDelta: true,
                  incGamma: null,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              کاهش دلتا
              <EmergencyOffset
                searchParams={{
                  ...searchParams,
                  incDelta: false,
                  incGamma: null,
                }}
              />
            </div>
          </div>
        );

      case SelectedTab.OffsetDelta:
        return (
          <div className="grid grid-cols-2 w-full gap-5">
            <div className="flex flex-col justify-start items-start gap-1">
              افزایش دلتا
              <OffsetDelta
                searchParams={{
                  ...searchParams,
                  incDelta: true,
                  incGamma: null,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-1">
              کاهش دلتا
              <OffsetDelta
                searchParams={{
                  ...searchParams,
                  incDelta: false,
                  incGamma: null,
                }}
              />
            </div>
          </div>
        );

      default:
        return <></>;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-2">
      <div className="w-min">
        <TabBox
          activeTab={selectedTab}
          children={tabs}
          onChange={(_, i) => setSelectedTab(i)}
        />
      </div>
      {getTable()}
    </div>
  );
};

export default TablesWrapper;
